
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
export default {
  inject: ['info'],
  props: {
    tips: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const _time = dayjs().format('YYYY/MM/DD')
    let _huanjiType = 'jyhj'
    if (this.info.tradeEnvRank) {
      _huanjiType = 'jyhj'
    } else if (this.info.influenceRank && this.info.influenceRank != 'E') {
      _huanjiType = 'yxl'
    } else if (this.info.exposure && this.info.exposure.total && this.info.exposure.total > 0) {
      _huanjiType = 'bg'
    } else if (this.info.influenceRank && this.info.influenceRank == 'E') {
      _huanjiType = 'yxl'
    }

    const weburl = []
    this.info &&
      this.info.webSite &&
      this.info.webSite.forEach((item) => {
        if (item.type == 1) {
          weburl.push(item)
        }
      })

    return {
      lan: this.$store.state.LanguageCode,
      websites: weburl,
      updateTime: _time,
      huanjiType: _huanjiType,
      moduleShow: false,
      urltype: 'webUrl', // 网址跳转类型
      iframeshow: false,
      iframeurl: '',
      tipstype: '',
      ourl: '',
      urllistshow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    iszh() {
      if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh') return true
      return false
    }
  },
  mounted() {
    this.statistics('1', this.$store.state.allHost)

    document.addEventListener(
      'click',
      () => {
        this.urllistshow = false
      },
      { passive: true }
    )
    // console.log('文字版交易商[新版]PC头部')
  },
  methods: {
    async statistics(type, url, code = '') {
      // 统计type为1--浏览模式默认；type为2---广告点击；3---点击模式官方网址；4---开户网址；5---品专官方网址；6---品专开户地址;7---品专默认
      let spots = 5
      if (type == '1' && !this.$store.state.allHost.includes('brand=1')) spots = 5
      else if (type == '2')
        spots = 3 // 广告
      else if (type == '3' && !this.$store.state.allHost.includes('brand=1')) spots = 1
      else if (type == '4' && !this.$store.state.allHost.includes('brand=1')) spots = 4
      else if (type == '5' && this.$store.state.allHost.includes('brand=1')) spots = 11
      else if (type == '6' && this.$store.state.allHost.includes('brand=1')) spots = 12
      else if (type == '7' && this.$store.state.allHost.includes('brand=1')) spots = 10
      else if (type == '21') spots = 21
      else if (type == '20') spots = 20
      const param = {
        userid: this.$store.state.user.userId ? this.$store.state.user.userId : '', // 用户标识
        equipId: this.$Cookie.get('wiki-bfp'),
        platform: 3, // 平台类型
        apptype: 0, // 客户端类型
        ip: this.$store.state.userIp, // 用户ip
        ver: '0', // 版本
        equipinfo: 0, // 客户端类型
        country: this.$store.state.CountryCode, // 当前国家
        lang: this.$store.state.LanguageCode, // 当前语言
        type: 1, // 浏览类型
        code: code || this.info.traderCode, // 交易商code
        spots, // 点位类型 1网址 3广告 4开户网址 11品专网址 12品专开户网址
        url, // 对应网址
        jumpStatisticsUrl: this.$store.state.allHost
      }
      await this.$api.dealer.statistics(param).then((ret) => {
        console.log('网址弹窗iframe', ret)
        if (ret && ret.url) {
          if (type == '6' || type == '4' || type == '5' || type == '3') {
            const u = ret.url.includes('http') ? ret.url : `https://${ret.url}`
            this.iframeurl = u
            this.tipstype = String(ret.type)
          } else if (type == '20' || type == '21') {
            this.tipstype = String(ret.type)
          }
        }
      })
    },
    openUlr(item) {
      bus.$emit('openurlForTextTrader', item)
    },
    openlist() {
      this.urllistshow = !this.urllistshow
    },
    iframeif(bool) {
      // iframe显示状态
      this.iframeshow = bool
    },
    close() {
      // 关闭弹框
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.$refs.tisk && this.$refs.tisk.close()
      })
    },
    setStarTex() {
      // 评分等级
      const score = this.info.score
      let text = ''
      if (score >= 8.5) {
        text = 'Best'
      } else if (score >= 7 && score < 8.5) {
        text = 'Good'
      } else if (score >= 4 && score < 7) {
        text = 'Average'
      } else if (score < 4) {
        text = 'Negative'
      }
      return text
    },
    setStarIcon(fenshu) {
      try {
        let html = ''
        if (fenshu && !isNaN(fenshu)) {
          fenshu = Number(fenshu) + 1
          if (fenshu > 10) {
            fenshu = 10
          }
          const newScore = parseInt(fenshu / 2)
          if (newScore > 0) {
            for (let i = 0; i < newScore; i++) {
              html += "<div class='iconfont full icon-Frame-3'></div>"
            }
          }
          let empty = 0
          if (fenshu % 2 >= 1) {
            empty = 1
            html += "<div class='half'><div class='iconfont empty icon-Frame-3'></div></div>"
          }

          const hfi = 5 - (newScore + empty)
          for (let s = 0; s < hfi; s++) {
            html += "<div class='iconfont empty icon-Frame-3'></div>"
          }
        }
        return html
      } catch {
        return ''
      }
    },
    TakeMax4Lable() {
      if (this.headData && this.headData.labels && this.headData.labels.length > 4) {
        return this.headData.labels.slice(0, 4)
      } else {
        return this.headData.labels
      }
    },
    GetEnvLevel() {
      let strs = 'Worst'
      if (!(this.info && this.info.tradeEnv && this.info.tradeEnv.Grade)) {
        return strs
      }
      switch (this.info.tradeEnv.Grade) {
        case 'AAA':
          strs = 'Best'
          break
        case 'AA':
          strs = 'Excellent'
          break
        case 'A':
          strs = 'Good'
          break
        case 'B':
          strs = 'Average'
          break
        case 'C':
          strs = 'Poor'
          break
        case 'D':
          strs = 'Worst'
          break
        default:
          strs = 'Worst'
      }

      return strs
    },
    GetUpdateTime() {
      if (this.info && this.info && this.info.wiki_timestamp) {
        return this.momentSpecialTime(this.info.wiki_timestamp)
      } else {
        return this.$v('{0}年').replace('{0}', 1)
      }
    },
    momentSpecialTime(timestamp) {
      if (!timestamp) {
        return this.$v('{0}年').replace('{0}', 1)
      }
      const offsetGMT = new Date().getTimezoneOffset() * 60 * 1000
      const now = new Date().getTime() - offsetGMT
      if (String(timestamp).includes('T')) {
        timestamp = Date.parse(timestamp)
      }
      if (`${timestamp}`.length < 12) timestamp = timestamp * 1000
      const timer = new Date(timestamp - offsetGMT)
      let time = ''
      const momen = now - timer
      switch (true) {
        case momen < 3600000:
          time = this.$v('{0}分钟').replace('{0}', Math.round(momen / 60000))
          break
        case momen >= 3600000 && momen < 86400000:
          time = this.$v('{0}小时').replace('{0}', Math.round(momen / 3600000))
          break
        case momen >= 86400000 && momen < 259200000:
          time = this.$v('{0}天').replace('{0}', Math.round(momen / 86400000))
          break
        case momen >= 259200000 && momen < 604800000:
          time = this.$v('{0}周').replace('{0}', Math.round(momen / 259200000))
          break
        case momen >= 604800000 && momen < 7257600000:
          time = this.$v('{0}月').replace('{0}', Math.round(momen / 604800000))
          break
        case momen >= 7257600000:
          time = this.$v('{0}年').replace('{0}', Math.round(momen / 7257600000))
          break
        default:
          time = this.$v('{0}年').replace('{0}', 9)
          break
      }
      return time
    },
    GetHuanJinWidth() {
      if (this.lan == 'fr') {
        return '286px'
      } else if (this.lan == 'pt') {
        return '278px'
      } else {
        return ''
      }
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    },
    fuzhi(val) {
      // 复制文本
      if (!val) {
        return
      }
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.select()
      document.execCommand('Copy')
      this.$message({
        message: this.$v('复制成功'),
        type: 'success'
      })
      document.body.removeChild(input)
    }
  }
}
